export const CANCELLATION_REASON_VENDOR_NO_QUOTE =
  'Vendor did not provide quote during expected time window';

export const CANCELLATION_REASON_ALL_QUOTES_EXPIRED = 'ALL_QUOTES_EXPIRED';
export const CANCELLATION_REASON_MANUALLY_CANCELLED =
  'AZ Translate Tool - User has manually cancelled vendor order.';

export const CANCELLATION_REASON_DISPLAY_MAP: Readonly<Record<string, string>> =
  {
    [CANCELLATION_REASON_VENDOR_NO_QUOTE]:
      'Vendors did not provide quote during expected time window',
    [CANCELLATION_REASON_ALL_QUOTES_EXPIRED]: 'All vendor quotes expired.',
    [CANCELLATION_REASON_MANUALLY_CANCELLED]:
      'The user manually cancelled the job',
  };

export function formatCancellationReason(
  reason: string | null | undefined,
): string {
  const trimmed = reason?.trim() ?? '';
  if (trimmed.length === 0) {
    return '';
  }
  return CANCELLATION_REASON_DISPLAY_MAP[trimmed] ?? trimmed;
}
